"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownContext = void 0;
var React = _interopRequireWildcard(require("react"));
const DropdownContext = exports.DropdownContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  DropdownContext.displayName = 'DropdownContext';
}